__turbopack_context__.v({
  "iframe": "VideoIframe-module__2fz7Nq__iframe",
  "videoWrapper": "VideoIframe-module__2fz7Nq__videoWrapper",
});
